import {Badge} from "antd";
import {Link} from "react-router-dom";
import {DownCircleOutlined, RetweetOutlined, CloseCircleOutlined} from '@ant-design/icons';

const statusIcon = {
    pending: <RetweetOutlined className="wait-icon"/>,
    verified: <DownCircleOutlined className="accepted-icon"/>,
    rejected: <CloseCircleOutlined className="rejected-icon"/>,
};

const statusColor = {
    "no-delegate": "#6E7BFF",
    started: "#F580EA",
    archived: "#B6BED4",
}

export const columns = [
    {
        title: 'Delegate',
        dataIndex: 'name',
        key: "name",
        sorter: true,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        // filters: [
        //     {
        //         text: 'No Delegate',
        //         value: 'No Delegate',
        //     },
        //     {
        //         text: 'Started',
        //         value: 'Started',
        //     },
        //     {
        //         text: 'Archived',
        //         value: 'Started',
        //     },
        // ],
        // onFilter: (value, record) => {
        //     return record.status.includes(value)
        // },
        render: (_, {status}) => <span><Badge color={statusColor[status]}/>{status}</span>,
    },
    {
        title: 'Date',
        dataIndex: 'date',
        key: "date",
        responsive: ['md'],
        sorter: true,
    },
    {
        title: 'Mission Type',
        dataIndex: 'type',
        key: 'type',
        responsive: ['lg'],
        sorter: true,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        responsive: ['md'],
        sorter: true,
        render: (amount) => <span>{`$ ${amount}`}</span>,
    },
    {
        title: '',
        dataIndex: 'details',
        key: "details",
        render: (_, record) => <Link to={`/missions/${record.id}`}>Manage</Link>,
    },
];
